import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { LOGO_URL } from "@/lib/content";

const links = [
  { href: "#modules", label: "Programme" },
  { href: "#formules", label: "Formules" },
  { href: "#sessions", label: "Sessions" },
  { href: "#centres", label: "Centres" },
  { href: "#galerie", label: "Galerie" },
  { href: "#faq", label: "FAQ" },
];

export default function Navbar({ onCtaClick }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-black/85 backdrop-blur-md border-b border-zinc-800"
          : "bg-transparent border-b border-transparent"
      }`}
      data-testid="site-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-between h-20">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
          <img src={LOGO_URL} alt="Horsepower" className="h-10 w-10 object-contain" />
          <div className="leading-none">
            <div className="font-display text-xl text-white">HORSEPOWER</div>
            <div className="font-mono text-[10px] text-[#FFD60A] tracking-[0.3em]">ACADEMY</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm text-zinc-300 hover:text-[#FFD60A] transition-colors uppercase tracking-wider font-medium"
              data-testid={`nav-link-${l.label.toLowerCase()}`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:block">
          <button
            onClick={() => onCtaClick("call_booking", { campaign: "cta-navbar" })}
            className="px-5 py-2.5 bg-[#FFD60A] text-black font-bold uppercase text-sm tracking-wider hover:bg-yellow-300 transition-all hover:-translate-y-0.5"
            data-testid="nav-cta-button"
          >
            Réserver un appel
          </button>
        </div>

        <button
          onClick={() => setOpen(!open)}
          className="lg:hidden text-white p-2"
          aria-label="Menu"
          data-testid="nav-mobile-toggle"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-black border-t border-zinc-800 px-6 py-6 space-y-4">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block text-zinc-300 uppercase tracking-wider font-medium"
              data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
            >
              {l.label}
            </a>
          ))}
          <button
            onClick={() => {
              setOpen(false);
              onCtaClick("call_booking", { campaign: "cta-navbar-mobile" });
            }}
            className="w-full py-3 bg-[#FFD60A] text-black font-bold uppercase tracking-wider"
            data-testid="mobile-nav-cta"
          >
            Réserver un appel
          </button>
        </div>
      )}
    </header>
  );
}
